const PRICE_TYPE = {
    FLAT_FEE: 'FLAT_FEE',
    QUANTITY_BASED: 'QUANTITY_BASED',
    PERCENTAGE_BASED: 'PERCENTAGE_BASED'
};

const OPTION_TYPE = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    QUANTITY: 'QUANTITY'
}

const DEFAULT_OPTION_ID = {
    MILEAGE: 'MILEAGE',
    TERM: 'TERM'
}

const DEFAULT_OPTION = {
    [DEFAULT_OPTION_ID.MILEAGE]: {
        id: DEFAULT_OPTION_ID.MILEAGE,
        type: OPTION_TYPE.MULTIPLE_CHOICE,
        name: 'mileage',
        required: true,
        option: [
            {
                name: '1000',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1
            },
            {
                name: '2000',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.1
            },
            {
                name: '3000',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.2
            },
            {
                name: '4000',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.3
            }
        ]
    },
    [DEFAULT_OPTION_ID.TERM]: {
        id: DEFAULT_OPTION_ID.TERM,
        type: OPTION_TYPE.MULTIPLE_CHOICE,
        name: 'term',
        required: true,
        option: [
            {
                name: '1',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.6
            },
            {
                name: '3',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.4
            },
            {
                name: '6',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.2
            },
            {
                name: '12',
                priceBase: PRICE_TYPE.PERCENTAGE_BASED,
                priceValue: 1.0
            }
        ]
    }
}

exports = module.exports = {
    PRICE_TYPE,
    DEFAULT_OPTION_ID,
    OPTION_TYPE,
    DEFAULT_OPTION
}